export default __webpack_public_path__ + "static/media/Parallax-HUD-Artificial Horizon.89d855d8.jpg";